import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

import { Notification, NotificationType } from './notification';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private _subject = new Subject<Notification>();
  private _idx = 0;

  constructor() { }

  getObservable(): Observable<Notification> {
    return this._subject.asObservable();
  }

  info(message: string, timeout = 3000, title = null) {
    this._subject.next(new Notification(
      this._idx++, NotificationType.info, title, message, timeout
    ));
  }

  success(message: string, timeout = 3000, title = null) {
    this._subject.next(new Notification(
      this._idx++, NotificationType.success, title, message, timeout
    ));
  }


  warning(message: string, timeout = 3000, title = null) {
    this._subject.next(new Notification(
      this._idx++, NotificationType.warning, title, message, timeout
    ));
  }


  error(message: string, timeout = 3000, title = null) {
    this._subject.next(new Notification(
      this._idx++, NotificationType.error, title, message, timeout
    ));
  }

}
